import lines from "../../asset/Home/lines.svg";
import redCircle from "../../asset/Home/redCircle.svg";
import yellowCircle from "../../asset/Home/yellowCircle.svg";
import rightLine from "../../asset/Home/rightline.svg";
import Navbar from "../../shared/Navbar";
import TrustedCompanies from "../../shared/TrustedCompanies";
import { useEffect, useState } from "react";
import salesHero from "../../asset/Sales/SalesMeet.svg";
import waveImage from "../../asset/Home/footerWawe.svg";
import { AnimatePresence, motion } from "framer-motion";
import {  SearchCheck, FlaskConical, Crosshair } from "lucide-react";
import logoVideo from "../../asset/Home/AI_LOGO.mp4";
import AboutSection from "../../components/SalesPage/AboutUS";
import Footer from "../../shared/Footer";
import FAQSection from "../../components/HomePage/FAQ";
import HowItWorks from "../../components/SalesPage/HowItWorks";
import { useNavigate } from "react-router-dom";
import Features from "../../components/SalesPage/Features";
import BusinessImpact from "../../components/SalesPage/BusinessImpact";
import Testimonial from "../../shared/Testimonials";

function Hero() {
  const [showChat, setShowChat] = useState(false);
  const [isHidden, setIsHidden] = useState(false);
  const navigate = useNavigate();

  const goToSection = (id) => {
    navigate("/", {
      state: {
        scrollTo: id,
      },
    });
  };
  useEffect(() => {
    const heroTimer = setTimeout(() => {
      setShowChat(true);
    }, 950);

    return () => clearTimeout(heroTimer);
  }, []);
  const tabs = [
    // {
    //   name: "Transcript",
    //   icon: FileText,
    //   messages: [
    //     "Good morning, Rajesh. Thank you for taking the time to meet with us today. How are you doing?",
    //     "Good morning. I'm doing well, thank you.",
    //     "Great to hear that. Before we begin, could you tell me a little about your current hiring process and how you're handling background verification today?",
    //     "Currently, we work with a verification vendor. Most of the process is manual and takes around 7–10 days.",
    //     "I understand. That's actually one of the common challenges we hear from HR teams—long turnaround times, multiple follow-ups, and limited visibility into verification status.",
    //     "Yes, that's something our team faces quite often.",
    //     "HireStar simplifies background verification with AI-powered automation, faster turnaround times, and real-time tracking.",
    //   ],
    // },
    {
      name: "Discovery",
      icon: SearchCheck,
      messages: [
        "How do you track sales rep performance?",
        "Why: Shows what they measure today.",
        "How do average performers reach top-performer conversion?",
        "Why: Surfaces the consistency gap.",
        "How do you review demo meetings?",
        "Why: Shows if demos get real feedback.",
        "If your top performer left, how would you protect revenue?",
        "Why: Surfaces key-person risk.",
        "Same framework for every client, despite different buying intent?",
        "Why: Shows if their process adapts or is one-size-fits-all."
      ],
    },
    {
      name: "Solution",
      icon: FlaskConical,
      messages: [
        "Hard to track performance consistently — want automatic, call-level data?",
        "We capture data from every call automatically — objective tracking across the whole team.",
        "Average reps not hitting top-rep conversion — want their playbook live?",
        "We feed your best reps' winning responses to everyone in real time — average reps close like top ones.",
        "Demo reviews inconsistent — want every demo auto-reviewed?",
        "Every demo gets captured and analyzed automatically — consistent feedback, not just what a manager catches.",
        "Worried about losing a top performer's knowledge?",
        "We turn their technique into data and framework not tribal knowledge — it stays even if they leave."
      ],
    },
    {
      name: "Objection",
      icon: Crosshair,

      messages: [
        "“Can the AI actually understand context that well, what if it gives bad advice live?”",
        "It reads context at a near-human level. Bad suggestions are rare, and flagging one takes seconds while directly improving the model.",
        "“Does this work with Zoom, Teams, Meet — all of them?”",
        "Yes, it integrates seamlessly with Zoom, Teams, and Meet — no workflow disruption.",
        "“Does it work well with different accents, will it understand our niche terminology?”",
        "No issue — it handles diverse accents, and onboarding customizes it with your data so it’s fluent in your team’s language.",
        "“What if it lags during a live call, does the AI respond fast enough to be useful?”",
        "Response time is a top priority, reliable even during fast-paced live calls."
      ],
    },
  ];

  const [activeTab, setActiveTab] = useState(0);
  const [visibleLines, setVisibleLines] = useState(0);
  useEffect(() => {
    setVisibleLines(0);

    let line = 0;

    const lineTimer = setInterval(() => {
      line++;

      if (line <= tabs[activeTab].messages.length) {
        setVisibleLines(line);
      }

      if (line >= tabs[activeTab].messages.length) {
        clearInterval(lineTimer);
      }
    }, 450);

    const tabTimer = setTimeout(() => {
      setActiveTab((prev) => (prev + 1) % tabs.length);
    }, tabs[activeTab].messages.length * 1000);

    return () => {
      clearInterval(lineTimer);
      clearTimeout(tabTimer);
    };
  }, [activeTab]);
  return (
    <>
      {" "}
      <Navbar />
      <section className="w-full overflow-hidden">
        {/* ================= HERO ================= */}
        <div className="relative px-3 sm:px-4">
          <div
            className="
						relative
						overflow-hidden
						bg-[#F8F5F5]
						rounded-[20px]
						w-full
                        max-w-full
             min-h-[540px]

sm:min-h-[760px]

md:min-h-[700px]

lg:min-h-[860px]

xl:min-h-[900px]
						flex
						items-center
						justify-center
					"
          >
            {/* Left Circle */}
            <img
              src={redCircle}
              alt=""
              className="
							absolute
							top-[-5%]
							left-[-15%]
							w-[180px]
sm:w-[260px]
md:w-[420px]
lg:w-[700px]
xl:w-[850px]
							opacity-90
							pointer-events-none
						"
            />

            {/* Right Circle */}
            <img
              src={yellowCircle}
              alt=""
              className="
							absolute
							bottom-[-10%]
							right-[-15%]
							w-[260px]
                            sm:w-[380px]
                            md:w-[550px]
                            lg:w-[800px]
                            xl:w-[900px]
							opacity-90
							pointer-events-none
						"
            />

            {/* Left Lines */}
            <img
              src={lines}
              alt=""
              className="
							hidden
							md:block
							absolute
							-top-10
							left-0
							w-[550px]
							pointer-events-none
						"
            />

            {/* Right Lines */}
            <img
              src={rightLine}
              alt=""
              className="
							hidden
							md:block
							absolute
							top-0
							right-0
							h-full
							w-auto
							opacity-90
							pointer-events-none
						"
            />
            <div
              className="
    absolute
top-[40px]


md:top-[50px]

lg:top-[80px]
    left-1/2
    -translate-x-1/2

    w-full
    max-w-[1100px]

    text-center

    z-30
  "
            >
              <h1
                className="
      font-unbounded
      font-semibold
      text-[#484342]
      mt-5
      md:mt-12
     text-[24px]
md:text-[35px]
lg:text-[46px]
xl:text-[52px]

      leading-[1.1]
      tracking-[-0.03em]
    "
              >
                Your Best Closer, on Every Demo
              </h1>
              <p className="mt-4 text-[#0C0200] font-jakarta text-[11px] lg:text-[15px]  leading-2 md:leading-4 lg:leading-6 max-w-[270px] md:max-w-[600px] lg:max-w-5xl mx-auto">
                Sales AI is a real-time AI Sales Expert that works alongside
                your reps during live customer conversations - guiding
                discovery, recommending the right solutions, handling objections
                instantly, and delivering actionable insights after every call.
              </p>
              <div
                className="
                lg:mt-8
                md:mt-8
                mt-6
                flex
                flex-col
                md:flex-row
                items-center
                justify-center
                gap-3
              "
              >
                <button
                  onClick={() => goToSection("agents")}
                  className="
                bg-[#E8604A]
                text-white
                font-prompt
                font-semibold

                w-auto
                min-w-[140px]
                h-8
                lg:h-11
                md:h-9
                px-5
                lg:px-8
                md:px-8
text-[11px]
                lg:text-[15px]
                md:text-[14px]

                rounded-md
              "
                >
                  Watch 2-min Demo
                </button>

                <button
                  onClick={() => goToSection("live-demo")}
                  className="
                bg-white
                border
                border-gray-200
                font-prompt
                font-semibold

                w-auto
                min-w-[130px]

                 h-8
                lg:h-11
                md:h-9
                px-6
                lg:px-8
                md:px-8
                text-[11px]
                lg:text-[15px]
                md:text-[14px]

                rounded-md
                text-[#46453D]

                flex
                items-center
                justify-center

                gap-2
                sm:gap-3

                hover:shadow-md
                transition-all
              "
                >
                  <div
                    className="
      w-8 h-8
      rounded-full
      overflow-hidden
      shrink-0
    "
                  >
                    <video
                      autoPlay
                      muted
                      loop
                      playsInline
                      className="
        w-full
        h-full
        object-cover
        scale-[1.8]
      "
                    >
                      <source src={logoVideo} type="video/mp4" />
                    </video>
                  </div>

                  <span>Start Free Trial</span>
                </button>
              </div>
            </div>

            <div
              className="
    absolute

    left-1/2
    -translate-x-1/2

  top-[360px]

sm:top-[480px]

md:top-[330px]

lg:top-[370px]


    w-full

    flex
    justify-center

    z-20
  "
            >
              {/* ================= Main Dashboard ================= */}
              <motion.div
                initial={{
                  opacity: 0,
                  y: 120,
                }}
                animate={{
                  opacity: 1,
                  y: 0,
                }}
                transition={{
                  duration: 1,
                  ease: [0.22, 1, 0.36, 1],
                }}
                className="
relative

w-[300px]
sm:w-[430px]
md:w-[620px]
lg:w-[900px]
xl:w-[900px]
2xl:w-[980px]
"
              >
                <img
                  src={salesHero}
                  className="
                relative
                w-full
                h-auto

                z-20
                select-none
                pointer-events-none
                "
                />
                {/* Hide Toggle on Sales SVG */}
                <div
                  className="
absolute
font-poppins
left-[6%]
top-[10.4%]

lg:left-[6%]
lg:top-[11%]

md:left-[6%]
md:top-[10.7%]



z-40

flex
items-center
gap-1
"
                >
                  <span
                    className="
text-[5px]

md:text-[8px]
lg:text-[11px]
font-poppins
font-medium
text-[#555]
"
                  >
                    Hide
                  </span>

                  <button
                    onClick={() => {
                      setIsHidden(!isHidden);
                      setShowChat(isHidden);
                    }}
                    className={`
relative

w-[13px]
h-[7px]



md:w-[22px]
md:h-[11px]

lg:w-[30px]
lg:h-[17px]

rounded-full
transition-all

${isHidden ? "bg-[#E8604A]" : "bg-[#B9B9B6]"}
`}
                  >
                    <span
                      className={`
absolute
top-1/2
-translate-y-1/2

rounded-full
bg-white

transition-all

w-[5px]
h-[5px]

lg:mr-[1px]
md:mr-[1px]
md:w-[9px]
md:h-[9px]

lg:w-[12px]
lg:h-[12px]

${isHidden ? "left-[1px]" : "right-[1px]"}
`}
                    />
                  </button>
                </div>
                {/* ================= Glass Card ================= */}

                <AnimatePresence mode="wait">
                  {!isHidden && showChat && (
                    <motion.div
                      initial={{
                        opacity: 0,
                        x: 90,
                        scale: 0.94,
                      }}
                      animate={{
                        opacity: 1,
                        x: 0,
                        scale: 1,
                      }}
                      exit={{
                        opacity: 0,
                        x: 90,
                        scale: 0.94,
                      }}
                      transition={{
                        delay: 0.1,
                        duration: 0.5,
                        ease: [0.22, 1, 0.36, 1],
                      }}
                      className="
absolute

lg:right-[5.5%]
top-[9%]
lg:top-[9.2%]

right-[5%]

w-[48%]
h-[60%]

min-w-[130px]
max-w-[420px]

min-h-[155px]
max-h-[450px]
md:w-[300px]
md:h-[310px]

lg:w-[420px]
lg:h-[450px]

rounded-[7px]

overflow-hidden

border
border-white/20

backdrop-blur-[40px]

bg-[linear-gradient(180deg,rgba(217,217,217,0.10)_0%,rgba(115,115,115,0.05)_100%)]

shadow-[0_18px_60px_rgba(0,0,0,.18)]

z-50

font-poppins
"
                    >
                      {/* ================= Header ================= */}

                      <div
                        className="
      relative
     h-[22px]
sm:h-[25px]
md:h-[30px]
lg:h-[35px]

      flex
      items-center
      justify-center

      border-b
      border-white/20

      bg-[rgba(255,255,255,.18)]
      backdrop-blur-[82px]
    "
                      >
                        <img
                          src={waveImage}
                          alt="wave icon"
                          className="
absolute
left-2
sm:left-3
lg:left-5

w-4
sm:w-5
md:w-7
lg:w-9
"
                        />

                        <h3
                          className="text-[7px]
sm:text-[8px]
md:text-[10px]
lg:text-[13px] font-medium text-[#545454]"
                        >
                          Hirestar Sales Agent
                        </h3>
                      </div>

                      {/* ================= Tabs ================= */}

                      <div
                        className="
      flex
      items-end
      justify-between

      px-[4px]
      md:px-[8px]
      lg:px-2

      pt-[3px]
      sm:pt-[3px]
      md:pt-[5px]
      lg:pt-1

      relative
      z-30
"
                      >
                        {tabs.map((tab, index) => {
                          const Icon = tab.icon;

                          return (
                            <motion.button
                              key={tab.name}
                              layout
                              whileHover={{
                                y: -1,
                              }}
                              transition={{
                                type: "spring",
                                stiffness: 280,
                                damping: 24,
                              }}
                              onClick={() => setActiveTab(index)}
                              className={`
        relative

        flex
        items-center
        justify-center
        lg:gap-3

        lg:px-[26px]
        lg:mb-[2px]
        lg:h-[32px]
    px-[3px]
    mb-[2px]
md:px-[5px]

h-[12px]
md:h-[24px]
lg:h-[36px]

gap-[1px]
md:gap-[4px]
lg:gap-2

text-[5px]
sm:text-[6px]
md:text-[10px]
lg:text-[13px]
        text-[12px]
        italic
        font-medium

        rounded-t-[3px]

        transition-all
        duration-300

        ${
          activeTab === index
            ? `
            text-[#FFADA0]

            bg-[linear-gradient(180deg,rgba(80,75,75,.49)_6.3%,rgba(115,115,115,.49)_15.41%)]

            backdrop-blur-[82px]
            rounded-t-[2px]
            lg:ounded-t-[8px]
            md:rounded-t-[6px]
translate-y-[1px]

            z-40
          `
            : `
            text-white/90

            hover:text-white

            z-10
          `
        }
      `}
                            >
                              <Icon
                                strokeWidth={1.8}
                                className={`
    w-[5px]
    h-[5px]

    sm:w-[7px]
    sm:h-[7px]

    md:w-[10px]
    md:h-[10px]

    lg:w-[15px]
    lg:h-[15px]

    ${activeTab === index ? "text-[#FFADA0]" : "text-white/90"}
  `}
                              />

                              <span
                                className={
                                  activeTab === index
                                    ? "text-[#FFADA0]"
                                    : "text-white/90"
                                }
                              >
                                {tab.name}
                              </span>
                            </motion.button>
                          );
                        })}
                      </div>

                      {/* ================= BG Card ================= */}

                      <div
                        className="
      relative

      mx-[4.5px]
      md:mx-2
      lg:mx-2

      -mt-[2px]

      h-[115px]
md:h-[248px]
lg:h-[373px]

      rounded-[6px]
      rounded-tl-none
                  rounded-tr-none

      backdrop-blur-[82px]

      bg-[linear-gradient(360deg,rgba(80,75,75,.49)_6.3%,rgba(115,115,115,.49)_15.41%)]

    p-[3px]
sm:p-[5px]
md:p-[5px]
lg:p-[6px]

      z-20
    "
                      >
                        {/* ================= Content Card ================= */}

                        <div
                          className="
    h-full
    rounded-[6px]
    bg-[#00000040]
    border
    border-white/10
    font-Poppins
   px-1

md:px-2
lg:px-3

pt-1
sm:pt-2
md:pt-2
lg:pt-3

pb-1
sm:pb-2
md:pb-2
lg:pb-3

    overflow-hidden

    flex
    flex-col
  "
                        >
                          <div className="flex-1 overflow-hidden">
                            <AnimatePresence mode="wait">
                              <motion.div
                                key={activeTab}
                                initial={{
                                  opacity: 0,
                                  x: 20,
                                  filter: "blur(8px)",
                                }}
                                animate={{
                                  opacity: 1,
                                  x: 0,
                                  filter: "blur(0px)",
                                }}
                                exit={{
                                  opacity: 0,
                                  x: -20,
                                  filter: "blur(8px)",
                                }}
                                transition={{
                                  duration: 0.8,
                                  ease: "easeInOut",
                                }}
                                className="h-full"
                              >
                                {tabs[activeTab].messages
                                  .slice(0, visibleLines)
                                  .map((message, index) => (
                                    <motion.div
                                      key={index}
                                      initial={{
                                        opacity: 0,
                                        x: -8,
                                      }}
                                      animate={{
                                        opacity: 1,
                                        x: 0,
                                      }}
                                      transition={{
                                        delay: index * 0.12,
                                        duration: 0.3,
                                      }}
                                      className="
flex

gap-[2px]
md:gap-2

mb-[3px]
sm:mb-1
md:mb-2
lg:mb-2
"
                                    >
                                      <div
                                        className="w-[28px]
sm:w-[36px]
md:w-[55px]
lg:w-[82px]

text-[4px]
sm:text-[5px]
md:text-[8px]
lg:text-[12px] shrink-0   text-[#ECECEC]"
                                      >
                                        {index % 2 === 1
                                          ? "Hirestar.io :"
                                          : "HR Manager :"}
                                      </div>

                                      <p
                                        className="text-white text-[4px] 
sm:text-[5px]
md:text-[7px]
lg:text-[11px]

leading-[1.15]
sm:leading-[1.2]
md:leading-[1.35]
lg:leading-4"
                                      >
                                        {message}
                                      </p>
                                    </motion.div>
                                  ))}
                              </motion.div>
                            </AnimatePresence>
                          </div>
                          {/* ================= Dots ================= */}
                          <div className="mt-auto flex items-center justify-center gap-1 ">
                            {tabs.map((_, i) => (
                              <motion.button
                                key={i}
                                onClick={() => setActiveTab(i)}
                                layout
                                animate={{
                                  width:
                                    activeTab === i
                                      ? window.innerWidth < 640
                                        ? 10
                                        : window.innerWidth < 1024
                                          ? 14
                                          : 20
                                      : window.innerWidth < 640
                                        ? 3
                                        : window.innerWidth < 1024
                                          ? 5
                                          : 8,
                                  opacity: activeTab === i ? 1 : 0.4,
                                }}
                                transition={{
                                  type: "spring",
                                  stiffness: 280,
                                  damping: 24,
                                }}
                                className={`
       h-[3px]
sm:h-[4px]
md:h-[6px]
lg:h-[8px]
        rounded-full
        ${activeTab === i ? "bg-[#FF7B60]" : "bg-white/35"}
      `}
                              />
                            ))}
                          </div>
                        </div>
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </motion.div>
            </div>
          </div>
          {/* ================= Dashboard ================= */}

          <motion.div
            initial={{
              opacity: 0,
              x: -60,
              y: -15,
              scale: 0.8,
              rotate: -6,
            }}
            whileInView={{
              opacity: 1,
              x: 0,
              y: 0,
              scale: 1,
              rotate: 0,
            }}
            viewport={{ once: true, amount: 0.5 }}
            transition={{
              duration: 1.15,
              delay: 0.25,
              type: "spring",
              stiffness: 90,
              damping: 18,
              mass: 1.1,
            }}
            whileHover={{
              y: -4,
              scale: 1.06,
              transition: { duration: 0.2 },
            }}
            className="
    absolute
    hidden
lg:block
    left-[13%]
    top-[55%]
    font-poppins
    bg-white
font-style: italic
    px-4
    py-[4.9px]

    rounded-md

    text-[12px]
    font-medium

    font-jakarta
    text-[#555555]

    shadow-md

    z-30
  "
          >
            Lead Intent Scoring
          </motion.div>
          <motion.div
            initial={{
              opacity: 0,
              x: -60,
              y: 25,
              scale: 0.8,
              rotate: 5,
            }}
            whileInView={{
              opacity: 1,
              x: 0,
              y: 0,
              scale: 1,
              rotate: 0,
            }}
            viewport={{ once: true, amount: 0.5 }}
            transition={{
              duration: 1.15,
              delay: 0.55,
              type: "spring",
              stiffness: 90,
              damping: 18,
              mass: 1.1,
            }}
            whileHover={{
              y: -4,
              scale: 1.06,
            }}
            className="
    absolute
    hidden
lg:block
    left-[11%]
    bottom-[16%]
font-poppins
    bg-white

    px-4
    py-[4.9px]

    rounded-md

    text-[12px]
    font-medium
font-style: italic
    font-jakarta
    text-[#555555]

    shadow-md

    z-30
  "
          >
            Real-Time Guidance
          </motion.div>
          <motion.div
            initial={{
              opacity: 0,
              x: 60,
              y: -15,
              scale: 0.8,
              rotate: 6,
            }}
            whileInView={{
              opacity: 1,
              x: 0,
              y: 0,
              scale: 1,
              rotate: 0,
            }}
            viewport={{ once: true, amount: 0.5 }}
            transition={{
              duration: 1.15,
              delay: 0.85,
              type: "spring",
              stiffness: 90,
              damping: 18,
              mass: 1.1,
            }}
            whileHover={{
              y: -4,
              scale: 1.06,
            }}
            className="
    absolute
    hidden
lg:block
    right-[11%]
    top-[50%]
font-poppins
    bg-white

    px-4
    py-[4.9px]

    rounded-md

    text-[12px]
    font-medium
font-style: italic
    font-jakarta
    text-[#555555]

    shadow-md

    z-30
  "
          >
            AI Objection Handling
          </motion.div>
          <motion.div
            initial={{
              opacity: 0,
              x: 60,
              y: 20,
              scale: 0.8,
              rotate: -5,
            }}
            whileInView={{
              opacity: 1,
              x: 0,
              y: 0,
              scale: 1,
              rotate: 0,
            }}
            viewport={{ once: true, amount: 0.5 }}
            transition={{
              duration: 1.1,
              delay: 1,
              type: "spring",
              stiffness: 90,
              damping: 18,
              mass: 1.1,
            }}
            whileHover={{
              y: -4,
              scale: 1.06,
            }}
            className="
    absolute
    hidden
lg:block
    right-[15%]
    bottom-[7%]
font-poppins
    bg-white
font-style: italic
    px-4
    py-[4.9px]

    rounded-md

    text-[12px]
    font-medium

    font-jakarta
    text-[#555555]

    shadow-md

    z-30
  "
          >
            Rep Coaching
          </motion.div>
        </div>
      </section>
      <TrustedCompanies />
      <AboutSection />
      <HowItWorks />
      <Features />
      <BusinessImpact />
      <Testimonial />
      <FAQSection />
      <Footer />
    </>
  );
}

export default Hero;
